<template>
  <Application>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row>
      <b-col>
        <b-card class="card--container">
          <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
              <span>Projetos</span>

              <!-- <b-button
                size="sm"
                variant="outline-primary"
              >
                <b-icon-plus /> Projeto
              </b-button> -->
            </div>
          </template>

          <div class="d-flex justify-content-center py-4" v-if="projects.isLoadingProjects">
            <b-spinner variant="secondary"></b-spinner>
          </div>

          <div v-else>
            <b-row>
              <b-col v-if="projects.projects.length === 0">
                <div class="text-center text-muted">
                  Nenhum projeto cadastrado
                </div>
              </b-col>
              <b-col
                v-for="(project, index) in projects.projects"
                :key="index"
                md="6"
                lg="4"
                xl="3"
                class="mb-2"
                v-else
              >
                <b-card
                  :title="project.title"
                  :sub-title="project.description"
                  @click="openProject(project.slug)"
                />
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </Application>
</template>

<script>
import { mapState } from 'vuex';
import router from '@/router/index';
import Application from '@/components/Application/Application.vue';

export default {
  components: {
    Application,
  },

  data() {
    return {
      loading: false,
      items: [
        { text: 'Dashboard', to: '/' },
        { text: 'Projetos', active: true },
      ],
    };
  },

  async created() {
    if (!this.projects.projects) {
      this.$store.dispatch('projects/fetchProjects', this.user.company_id);
    }
  },

  computed: {
    ...mapState(['projects']),
  },

  methods: {
    openProject(slug) {
      router.push({ path: `/projects/${slug}` });
    },
  },
};
</script>

<style lang="scss" scoped>
  .card {
    &--container {
      .card {
        transition: box-shadow .15s ease-out;

        &:hover {
          box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
          cursor: pointer;
        }

        &-body {
          padding: 1.25rem 1.25rem .75rem 1.25rem;
        }
      }
    }
  }
</style>
